export const PreceptorMetricsOrientationCounts = ({metrics}) => {
    return (
        <div className="card card-flush h-auto h-lg-100 mb-5 mb-lg-0 border border-gray-400">
            <div className="card-header py-7">
                <div className="m-0">
                    <div className="d-flex align-items-center mb-2">
                        <span className="fs-2hx fw-bold text-gray-800 me-2 lh-1 ls-n2">{metrics.success_rate}%</span>
                    </div>
                    <span className="fs-6 fw-semibold text-gray-700">My Orientees' Success Rate</span>
                </div>
            </div>
            <div className="card-body pt-0">
                <div className="mb-0">
                    <div className="separator"></div>
                    <div className="d-flex flex-stack py-6">
                        <div className="d-flex align-items-center me-5">
                            <div className="me-5">
                                <span className="fw-bold fs-5">Total Orientations Completed</span>
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <span className=" fw-bold fs-5 me-3">{metrics.total || 0}</span>
                        </div>
                    </div>
                    <div className="separator"></div>
                    <div className="d-flex flex-stack py-6">
                        <div className="d-flex align-items-center me-5">
                            <div className="me-5">
                                <span className="fw-bold fs-5">Successful Orientations</span>
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <span className=" fw-bold fs-5 me-3">{metrics.successful || 0}</span>
                        </div>
                    </div>
                    <div className="separator"></div>
                    <div className="d-flex flex-stack py-6">
                        <div className="d-flex align-items-center me-5">
                            <div className="me-5">
                                <span className="fw-bold fs-5">Unsuccessful Orientations</span>
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <span className=" fw-bold fs-5 me-3">{metrics.unsuccessful || 0}</span>
                        </div>
                    </div>
                    <div className="separator"></div>
                </div>
            </div>
        </div>
    )
}
